
<template>
    <div style="margin-left:50px;">
  
      <el-form style="display: flex;flex-wrap: wrap;">
  
          <el-form-item label="姓名:" style="display: flex;width: 33%;" >
              <!-- <el-select
                  placeholder="请选择姓名"
                  v-model="coursecancellationStatusInput"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select> -->
              <el-input v-model="input1" placeholder="请输入姓名"></el-input>
          </el-form-item>
  
  
          <el-form-item label="职级:" style="display: flex;width: 33%;">
              <el-select
                  placeholder="请选择职级"
                  v-model="input2"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr"
                  :key="item.jobId"
                  :value="item.jobId"
                  :label="item.jobName"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <!-- <el-form-item label="科目:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择科目"
                  v-model="input3"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr_s"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item> -->
  
  
  
          <!-- <el-form-item label="日期:" style="display: flex;width: 33%;"  label-width="75px">
              <el-date-picker
              style="width: 104%;margin-left: -139px;"
              v-model="dateTimeList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable>
              </el-date-picker>
          </el-form-item> -->
  
          <el-form-item label="培训状态:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择培训状态"
                  v-model="input4"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatuss"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="招聘渠道:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择招聘渠道"
                  v-model="input5"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatusss"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="内推人:" style="display: flex;width: 33%;" >
              <!-- <el-select
                  placeholder="请选择内推人"
                  v-model="coursecancellationStatusInput_ss"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select> -->
              <el-input v-model="input6" placeholder="请输入内推人"></el-input>
          </el-form-item>


          <el-form-item label="Boss来源负责人:" style="display: flex;width: 33%;" >
              <!-- <el-select
                  placeholder="请选择Boss来源负责人"
                  v-model="coursecancellationStatusInput_ss"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select> -->
              <el-input v-model="input7" placeholder="请输入Boss来源负责人"></el-input>
          </el-form-item>



          <el-form-item label="入职时间:" style="display: flex;width: 66%;" >
              <el-date-picker
                style="width: 100%;"
                v-model="dateTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable>
              </el-date-picker>
          </el-form-item>
  
          
          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
          </div>
  
      </el-form>
  
  
      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
          <!-- <el-table-column prop="courseDate" label="日期">
            <template slot-scope="scope">
               <span>{{scope.row.courseDate.substring(0,10)}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="realname" label="姓名"></el-table-column>
          <el-table-column prop="telephone" label="电话"></el-table-column>
          <el-table-column prop="teach" label="科目"></el-table-column>
          <el-table-column prop="jobTitleName" label="职级"></el-table-column>
          <el-table-column prop="entryTime" label="入职时间"></el-table-column>
          <el-table-column prop="recruitmentChannel" label="招聘渠道"></el-table-column>
          <el-table-column prop="introducerName" label="内推人"></el-table-column>
          <el-table-column prop="introducerName" label="通过状态"></el-table-column>
          <el-table-column prop="bossName" label="Boss来源负责人"></el-table-column>
          <el-table-column prop="trainPlan" label="培训进度">
            <template slot-scope="scope">
                <div v-if="scope.row.trainPlan === 1">未完成</div>
                <div v-if="scope.row.trainPlan === 2">已完成</div>
                <div v-if="scope.row.trainPlan === 3">未通过</div>
              </template>
          </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: space-around;">
                  <!-- <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button> -->
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                </div>
              </template>
          </el-table-column>
        </el-table>
  
  
  
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>
  
  
  
      <el-dialog title="培训档案详情" width="80%" :visible.sync="ShowDlong" :before-close="commitCler">
          
          <div style="display: flex;justify-content: space-between;margin-bottom: 50px;">
             <div>姓名：{{ newEdible.realname ? newEdible.realname : ''}}</div>
             <div style="">科目：{{ newEdible.teach  ? newEdible.teach  : ''}}</div>
             <div style="">职级：{{ newEdible.jobtitle  ? newEdible.jobtitle  : ''}}</div>
             <div style="">招聘渠道：{{ newEdible.recruitmentChannel  ? newEdible.recruitmentChannel  : ''}}</div>
             <div style="">内推人：{{ newEdible.introducerName  ? newEdible.introducerName  : ''}}</div>
             <div style="">boss来源负责人：{{ newEdible.bossName  ? newEdible.bossName  : ''}}</div>
             <div style="">入职时间：{{ newEdible.entryTime  ? newEdible.entryTime  : ''}}</div>
          </div>


          <div style="display: flex;margin-bottom: 50px;flex-wrap: wrap;height: 200px;overflow: auto;">
            <el-card class="box-card" style="padding:10px; width: 250px; margin-right: 10px;height: 100px;"  v-for="(itme, index) in newEdible.teacherTrainTaskDTOS" :key="index" >
                <div style="text-align: start;">方案名称: {{ itme.trainName }}</div>
                <!-- <div style="text-align: start;">培训状态：{{ itme.traiState ? itme.traiState : '未成功' }}</div> -->
                <div style="text-align: end;color: #00b6ff;" @click="handleTask(itme)">详情</div>
            </el-card>
          </div>


          <div v-if="handleDayShow">
            <div style="margin-bottom: 30px;">
                <el-steps :active="activeStep" simple style="">
                   <el-step v-for="(itme,index) in handleDayShowList.trainTaskDTOS" :key="index" 
                   :title="itme.numberDays == 1 ? '第一天' : itme.numberDays == 2 ? '第二天' : itme.numberDays == 3 ? '第三天' : itme.numberDays == 4 ? '第四天' : itme.numberDays == 5 ? '第五天' : itme.numberDays == 6 ? '第六天' : itme.numberDays == 7 ? '第七天' : itme.numberDays == 8 ? '第八天' : itme.numberDays == 9 ? '第九天' : itme.numberDays == 10 ? '第十天' : itme.numberDays == 11 ? '第十一天' : itme.numberDays == 12 ? '第十二天' : itme.numberDays == 13 ? '第十三天' : itme.numberDays == 14 ? '第十四天' : itme.numberDays == 15 ? '第十五天' : itme.numberDays == 16 ? '第十六天' : itme.numberDays == 17 ? '第十七天' : itme.numberDays == 18 ? '第十八天' : itme.numberDays == 19 ? '第十九天' : itme.numberDays == 20 ? '第二十天' : itme.numberDays == 21 ? '第二十一天' : itme.numberDays == 22 ? '第二十二天' : '第二十三天' "
                    @click.native="handleStep(itme,index)"></el-step>
                </el-steps>
            </div>
            <div style="display: flex;margin-bottom: 50px;flex-wrap: wrap;height: 250px;overflow: auto; margin-bottom: 10px;" >
                <el-card class="box-card" style="padding:10px; width: 300px; margin-right: 10px;height: 180px;margin-bottom: 10px;"  v-for="(itme, index) in handleDayShowList.trainTaskDTOS[activeStep].trainTaskInfoDTO" :key="index" >
                    <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">任务{{ index == 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' :
                                    index == 5 ? '六' : index === 6 ? '七' : index == 7 ? '八' : index === 8 ? '九' : index === 9 ? '十' :
                                    index == 10 ? '十一' : index == 11 ? '十二' : index == 12 ? '十三' : index == 13 ? '十四' : index == 14 ? '十五' :
                                    index == 15 ? '十六' : index == 16 ? '十七' : index === 17 ? '十八' : index === 18 ? '十九' : index === 20 ? '二十' :
                                    index == 21 ? '二十一' : index === 22 ? '二十二' : index == 23 ? '二十四' : index == 24 ? '二十五' : index === 25 ? '二十六' :
                                    index === 27 ? '二十八' : index === 28 ? '二十九' : index == 29 ? '三十' : '三十一'}}</div>
                    <div style="text-align: start;margin-bottom: 10px;" class="cssCls">任务名称：{{ itme.taskName }}</div>
                    <div style="text-align: start;margin-bottom: 10px;" class="cssCls">任务内容：{{ itme.taskContent }}</div>
                    <div style="text-align: start;margin-bottom: 10px;" class="cssCls">完成状态：{{ itme.teacherPerformance == 1 ? '未完成' :  itme.teacherPerformance == 2 ? '已完成' : '未通过' }}</div>
                    <div style="text-align: start;margin-bottom: 10px;" class="cssCls">审批状态：{{ itme.auditStatus == -2 ? '待提交' : itme.auditStatus == 1 ? '已审批' : itme.auditStatus == 0 ? '审批中' :  itme.auditStatus == -1 ? '已驳回' : '未通过' }}</div>
                    <div style="text-align: end;color: #00b6ff;" @click="handleDay(itme)">详情</div>
                </el-card>
            </div>
          </div>


          <div v-if="handleTaskDayShow">
            <div style="display: flex;margin-bottom: 50px;flex-wrap: wrap;height: 350px;overflow: auto;" >
                <el-card class="box-card" style="padding:10px; width: 250px; margin-right: 10px;">
                    <div style="text-align: start;margin-bottom: 10px;">方案名称：{{ handleTaskDayRow.taskName }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">提交人：{{ Rowrealname }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">
                        <div>相关资料：</div>
                        <div style="text-align: start;height: 47px; overflow-x: auto;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px; margin-top: 10px;">
                            <a style="margin-right: 10px;" v-for="(itme,index) in handleTaskDayRowData" :key="index" :href="itme.url">{{ itme.name }}</a>
                        </div>
                    </div>
                    <div style="text-align: start;margin-bottom: 10px;">提交日期：{{ handleTaskDayRow.createTime }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">参训人姓名：{{ handleTaskDayRow.teacherName }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">总结内容：{{ handleTaskDayRow.summarize }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">取消原因：{{ handleTaskDayRow.cancelCause }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">审批意见：{{ handleTaskDayRow.auditOpinion }}</div>
                    <div style="text-align: start;margin-bottom: 10px;">审批状态：
                        {{ handleTaskDayRow.auditStatus === -2 ? '待提交' :  handleTaskDayRow.auditStatus === -1 ? '已驳回' :  handleTaskDayRow.auditStatus === 0 ? '审批中' : handleTaskDayRow.auditStatus === 1 ? '已审批' : '未知' }}
                    </div>
                </el-card>
            </div>
          </div>

          

          <div></div>

          <div></div>
  
      </el-dialog>
      
  
  
      <el-dialog title="添加培训任务" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler">
          
          <el-form ref="form" :model="form" label-width="100px">
  
              <el-form-item label="培训名称:">
                  <el-input placeholder="请选择培训名称" v-model="Addform.TrainName" style="width: 100%" clearable> 
                  </el-input>
              </el-form-item>
  
              <el-form-item label="任务创建人:">
                <el-select
                  placeholder="请选任务创建人"
                  v-model="Addform.CreatorName"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                      v-for="item in getStudentsArr_s"
                      :key="item.id"
                      :value="item.id"
                      :label="item.realname">
                  </el-option>
              </el-select>
              </el-form-item>
  
             <el-form-item label="参加培训人:">
              <el-select
                  placeholder="请选择参加培训人"
                  v-model="Addform.TrainerName"
                  style="width: 100%"
                  clearable
                  filterable>
                   <el-option
                       v-for="item in coursecancellationStatus"
                       :key="item.id"
                       :value="item.id"
                       :label="item.realname" >
                   </el-option>
              </el-select>
             </el-form-item>
  
             <el-form-item label="培训内容:">
                  <div style="width: 100%;height: 250px;overflow-x: auto;display: flex;">
                      <el-radio  @click="clickitem(item.id)" border v-model="Addform.TrainingContent"
                           style="width: 130px; height: 100%;" v-for="(item, index) in planArr" :key="index" :label='item.id'>
                          <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                          <div style="text-align: left;"  v-for="(item1, index1) in item.planList" :key="index1">
                              <p>课节数:{{ item1.classNum }}</p>
                              <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                          </div>
                      </el-radio>
                  </div>
             </el-form-item>
  
             <el-form-item label="资料上传:">
                  <el-upload
                      class="upload-demo"
                      drag
                      action="#"
                      :on-remove="handleRemove"
                      :beforeUpload="beforeUpload"
                      :http-request="handleUpload"
                      :on-error="handleError"
                      :auto-upload="true"
                      show-file-list
                      :file-list="fileDataList"
                      multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
             </el-form-item>   
  
             <el-form-item label="审批人:">
                  <el-select
                      placeholder="请选择审批人"
                      v-model="Addform.ApprovedName"
                      style="width: 100%"
                      clearable
                      filterable >
                      <el-option
                          v-for="item in coursecancellationStatus"
                          :key="item.id"
                          :value="item.id"
                          :label="item.realname" >
                      </el-option>
                  </el-select>
             </el-form-item>
  
  
          </el-form>
  
  
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub">保存</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button>
          </div>
  
      </el-dialog>
  
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" :visible.sync="ShowapprovalOpinions" :before-close="approvalOpinionsCler">
          <el-input :autosize="{  minRows: 6, maxRows: 6 }"  type="textarea"  placeholder="请输入驳回内容"  v-model="approvalOpinionstextarea" maxlength="200" show-word-limit></el-input>
      
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions">确定</el-button>
          </div>
  
      </el-dialog>
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" width="30%" :visible.sync="ShowapprovalOpinions_Yes" :before-close="approvalOpinionsCler_Yes">
          
          <div style="">是否提交审批意见?</div>
  
          <div slot="footer" class="dialog-footer" style="text-align: center;">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="approvalOpinionsCler_Yes">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions_Yes">确定</el-button>
          </div>
  
      </el-dialog>
  
  
      <el-dialog :title="ShowDlongTitle1" :visible.sync="ShowDlong1" :before-close="commitCler1" width="70%">
        

         <!-- <el-form ref="form"  label-width="90px" style=" display: flex; flex-wrap: wrap;">
            <el-form-item label="方案名称:" style="text-align: start; width: 45%;margin-left: 10px;" class="disable-click">
                <el-input v-model="resData.trainName" placeholder="请输入内容"></el-input>
            </el-form-item>

            <el-form-item label="提交人:" style="text-align: start;width: 45%; margin-left: 35px;" class="disable-click">
               <el-input v-model="resData.teacherName" placeholder="请输入内容"></el-input>
            </el-form-item>

           <el-form-item label="相关资料:" style="text-align: start;width: 45%;margin-left: 10px;">
            <div style="text-align: start;height: 47px; overflow-x: auto;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">
                <a style="margin-right: 10px;" v-for="(itme,index) in resData.taskData" :key="index" :href="itme.url">{{ itme.name }}</a>
            </div>
           </el-form-item>

           <el-form-item label="提交日期:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
               <el-input v-model="resData.createTime" placeholder="请输入内容"></el-input>
           </el-form-item>

           <el-form-item label="参训人姓名:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click"> 
               <el-input v-model="resData.teacherName" placeholder="请输入内容"></el-input>
           </el-form-item>

           <el-form-item label="任务名称:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
               <el-input v-model="resData.taskName" placeholder="请输入内容"></el-input>
           </el-form-item>

           <el-form-item label="总结内容:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click">
               <el-input v-model="resData.summarize" placeholder="请输入内容"></el-input>
           </el-form-item>

           <el-form-item label="相关链接:" style="text-align: start;width: 45%;margin-left: 35px;">
                <div style="text-align: start;height: 47px; overflow-x: auto;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">
                    <a style="margin-right: 10px;" v-for="(itme,index) in resData.auditData " :key="index" :href="itme.url">{{ itme.name }}</a>
                </div>
           </el-form-item>

           <el-form-item label="取消原因:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click">
               <el-input v-model="resData.cancelCause" placeholder="请输入内容"></el-input>
           </el-form-item>

           <el-form-item label="审批状态:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
               <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">{{ resData.auditStatus === '-2'? '待提交' :  resData.auditStatus === '-1' ? '已驳回' :  resData.auditStatus === '0' ? '审批中' : resData.auditStatus === '1' ? '已审批' : '未通过' }}</div>
           </el-form-item>

           <el-form-item label="" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click" v-if="resData.auditOpinion">
           </el-form-item>

           <el-form-item label="审批意见:" style="text-align: start;width: 45%;margin-left: 36px;" class="disable-click" v-if="resData.auditOpinion">
               <el-input v-model="resData.auditOpinion"  show-word-limit :autosize="{ minRows: 6, maxRows: 6  }"></el-input>
           </el-form-item>

        </el-form> -->



        <div style=" display: flex;">

            <el-card class="box-card" style="width: 49%;">
                <div slot="header" class="clearfix">
                    <span>方案信息</span>
                </div>
                <el-form ref="form"  label-width="100px" style=" display: flex; flex-wrap: wrap;">
                    <el-form-item label="方案名称:" style="text-align: start; width: 100%;margin-left: 10px;" class="disable-click">
                        <el-input v-model="handleTaskDayRow.taskName" ></el-input>
                    </el-form-item>

                    <el-form-item label-width="100px" label="任务名称:" style="text-align: start;width: 100%;margin-left: 10px;" class="disable-click">
                        <el-input v-model="resData.taskName"></el-input>
                    </el-form-item>

                    <el-form-item label-width="100px" label="任务相关资料:" style="text-align: start;width: 100%;margin-left: 10px;">
                        <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">
                            <a style="margin-right: 10px;display: block;" v-for="(itme,index) in resData.taskData" :key="index" :href="itme.url">{{ itme.name }}</a>
                        </div>
                    </el-form-item>

                    <el-form-item label-width="100px" label="参训人姓名:" style="text-align: start;width: 100%;margin-left: 10px;" class="disable-click"> 
                        <el-input v-model="Rowrealname" ></el-input>
                    </el-form-item>
                </el-form>
            </el-card>

            <el-card class="box-card" style="width: 49%;margin-left: 10px;">
                <div slot="header" class="clearfix">
                    <span>参训人提交信息</span>
                </div>
                <el-form ref="form"  label-width="100px" style=" display: flex; flex-wrap: wrap;">
                    <el-form-item label="提交日期:" style="text-align: start; width: 100%;margin-left: 10px;" class="disable-click">
                        <el-input v-model="resData.commitDate"></el-input>
                    </el-form-item>

                    <el-form-item label-width="100px"  label="提交内容:" style="text-align: start;width: 100%;margin-left: 10px;" class="disable-click">
                        <el-input v-model="resData.summarize" ></el-input>
                    </el-form-item>

                    <el-form-item label-width="100px"  label="内容相关资料:" style="text-align: start;width: 100%;margin-left: 10px;">
                        <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">
                            <a style="margin-right: 10px;display: block;" v-for="(itme,index) in resData.auditData" :key="index" :href="itme.url">{{ itme.name }}</a>
                        </div>
                    </el-form-item>
                </el-form>
            </el-card>

        </div>

        <el-card class="box-card" style="width: 100%; margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>审批信息</span>
            </div>
            <el-form ref="form"  label-width="90px" style=" display: flex; flex-wrap: wrap;">
               <el-form-item label="审批人:" style="text-align: start; width: 45%;margin-left: 10px;" class="disable-click">
                   <el-input v-model="resData.auditName1" ></el-input>
               </el-form-item>

               <el-form-item label="审批状态:" style="text-align: start;width: 45%;margin-left: 35px;" class="disable-click">
                     <div style="text-align: start;border-radius: 4px; border: 1px solid #DCDFE6; padding-left: 10px;">{{ resData.auditStatus === -2 ? '待提交' :  resData.auditStatus === -1 ? '已驳回' :  resData.auditStatus === 0 ? '审批中' : resData.auditStatus === 1 ? '已审批' : '未通过' }}</div>
               </el-form-item>

               <el-form-item label="审批意见:" style="text-align: start;width: 45%;margin-left: 10px;" class="disable-click">
                     <el-input v-model="resData.auditOpinion"  show-word-limit :autosize="{ minRows: 6, maxRows: 6  }"></el-input>
                </el-form-item>
            </el-form>
         </el-card>
       

    </el-dialog>
  
  
  
  </div>
</template>
  
  <script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import Vue from 'vue';
  import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
  var $Vue = Vue.prototype
  import {  getStudentsType } from "@/api/fiveClassApi"
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import loadingUtils from "../utils/loading";
  import { isReturn } from "../utils/retnue";
  
  export default defineComponent({
  
      setup(props, { attrs, slots, emit, expose }){

          let newEdible = reactive( { realname:'',  teach:'',  jobtitle:'',  recruitmentChannel:'',  introducerName:'',bossName:'', entryTime:'', teacherTrainTaskDTOS:[]})
          let coursecancellationStatuss = ref([]) 
          let coursecancellationStatusss = ref([]) 
          let dateStepList = ref(['第一天','第二天','第三天','第四天','第五天'])
          let approvalOpinionstextarea = ref('')
          let ShowapprovalOpinions = ref(false)
          let getStudentsArr = ref([])
          let getStudentsArr_s = ref([])
          let coursecancellationStatus = ref([])
          let Rowrealname = ref('')
          let student = ref('')
          let student_s = ref('')
          let handleTaskDayRow = reactive({  auditData:'', summarize:'' , auditName1:'', auditName:'', auditOpinion:'', auditStatus:1, cancelCause:'', isAnswer:'', isAnswerComplete:'', summarize:'', taskAnswer:'', taskAnswerName:'', taskContent:'', taskData:[], taskName:'', taskNum:'', taskNumber:'', teacherPerformance:'', })
          let coursecancellationStatusInput = ref('')
          let coursecancellationStatusInput_s = ref('')
          let coursecancellationStatusInput_ss = ref('')
          let dateTimeList = ref([])
          let dataList = ref([])
          let requestParameters = reactive({pageSize:10,total:0,pageNum:1})
          let ShowDlong = ref(false)
          let ShowDlongDisabled = ref(false)
          let ShowDlongTitle = ref('编辑')
          let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:[], dateTimeList: '' })
          let AddShowDlong = ref(false)
          let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: '', TrainingContent:'', DataUpload: '', ApprovedName: '' })
          let planArr = ref([])
          let fileDataList = ref([])
          let ShowapprovalOpinions_Yes = ref(false)
          let taskList = ref([{ taskName:'初始化任务名称', taskState:'已完成' }, { taskName:'初始化任务名称', taskState:'未完成' }, { taskName:'初始化任务名称', taskState:'未完成' }, { taskName:'初始化任务名称', taskState:'未完成' }, { taskName:'初始化任务名称', taskState:'未完成' }, { taskName:'初始化任务名称', taskState:'未完成' }, { taskName:'初始化任务名称', taskState:'未完成' }])
          let handleDayShow = ref(false)
          let dayList = ref([ { taskState:'已完成' }, { taskState:'已完成' }, { taskState:'已完成' } ])
          let activeStep = ref(0)
          let handleTaskDayShow = ref(false)
          let dayTaskList = ref([ { taskState:'已完成' },{ taskState:'审批中' },{ taskState:'未完成', reason:'管理员驳回' } ])
          let input1 = ref('')
          let input2 = ref('')
          let input3 = ref('')
          let input4 = ref('')
          let input5 = ref('')
          let input6 = ref('')
          let input7 = ref('')
          let realname = ref('')
          let teach = ref('')
          let jobtitle = ref('')
          let recruitmentChannel = ref('')
          let introducerName = ref('')
          let bossName = ref('')
          let entryTime = ref('')
          let handleDayShowList = ref([])
          let handleTaskDayRowData = ref([])
          let dateTime = ref([])
          let ShowDlongTitle1 = ref('')
          let ShowDlong1 = ref(false)
          let resData = reactive({ })


          onMounted(()=>{
              handleAllApi()
          })
  
          watchEffect(() => {
              console.log(`Count is now 让子弹飞一会`);
          })
  
  
          const handleAllApi = () =>{
              getStudentsArr.value = [{ id: 1, realname : '李四' },{ id: 2, realname : '张三' },{ id: 3, realname : '王五' }]
              getStudentsArr_s.value = [{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }]
              coursecancellationStatus.value = [{ id: 1, realname : '唱' },{ id: 2, realname : '跳' },{ id: 3, realname : 'rap' }]
              dataList.value = [{ courseDate: '2024-01-14', courseStartTime: '张三', courseEndTime: '颇多野', subjectName: [{url:'https:baidu.com',name:'虚拟图片'},{url:'https:baidu.com',name:'虚拟图片2'}]  }]

              coursecancellationStatuss.value = [{ id: 1, realname : '未完成' },{ id: 2, realname : '已完成' },{ id: 3, realname : '未通过' }]
              coursecancellationStatusss.value = [{ id: 'BOSS直聘', realname : 'BOSS直聘' },{ id: '内推', realname : '内推' }]

              let data = { 
                    pageNum: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    teacherName: input1.value,
                    jobtitle: input2.value,
                    teach: input3.value,
                    trainPlan: input4.value,
                    recruitmentChannel: input5.value,
                    introducerName: input6.value,
                    bossName:input7.value,
                    entryTimeStart: dateTime.value[0] ? dateTime.value[0] + ' 00:00:00': '',
                    entryTimeEnd: dateTime.value[1] ? dateTime.value[1] + ' 00:00:00' : '',
                }
                axios.post(`${apiBaseUrl}/trainTask/trainRecordPage`, data,{
                    headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    if(res.data.code == 200){
                        handleMessage("查询成功", 'success')
                    }
                    dataList.value = res.data.data.records
                    requestParameters.pageNum = res.data.data.current
                    requestParameters.pageSize = res.data.data.size
                    requestParameters.total = res.data.data.total

                }).catch(error => {
                    console.error(error)
                })


              axios.get(`${apiBaseUrl}/teacher/query/job`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                  getStudentsArr.value = res.data.data.list
              }).catch(error => {
                  console.log(error);
              })

              axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{
                  headers:{
                      'authorization': sessionStorage.getItem('tokenInfo')
                  },
              }).then(res => {
                  isReturn(res.code)
                  planArr.value = res.data.data.records
              }).catch(error => {
                  console.error(error)
              })
          }
  
          const handleMessage = (message,type) =>{
               $Vue.$message({ message, type, duration: 500 });
          }
  
          const approvalOpinionsCler = ()=>{
              approvalOpinionstextarea.value = ''
              ShowapprovalOpinions.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const exportBtns = () =>{
            let data = {
                teacherName: input1.value,
                jobtitle: input2.value,
                teach: input3.value,
                trainPlan: input4.value,
                recruitmentChannel: input5.value,
                introducerName: input6.value,
                bossName:input7.value,
                entryTimeStart: dateTime.value[0] ?  dateTime.value[0] + ' 00:00:00' : '',
                entryTimeEnd: dateTime.value[1] ?  dateTime.value[1] + ' 00:00:00' : '',
            }
            axios.post(`${apiBaseUrl}/trainTask/exportTrainRecord`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "档案管理.xlsx"; 
                    downloadLink.click();
                    handleMessage('导出成功', 'success')
                }
                else{
                    handleMessage('导出失败', 'error')
                }
            })
          }
          const searchBtns = () =>{
            let data = { 
                pageNum: requestParameters.pageNum,
                pageSize: requestParameters.pageSize,
                teacherName: input1.value,
                jobtitle: input2.value,
                teach: input3.value,
                trainPlan: input4.value,
                recruitmentChannel: input5.value,
                introducerName: input6.value,
                bossName:input7.value,
                entryTimeStart: dateTime.value[0] ? dateTime.value[0] + ' 00:00:00' : '',
                entryTimeEnd: dateTime.value[1] ? dateTime.value[1] + ' 00:00:00' : '',

            }
            axios.post(`${apiBaseUrl}/trainTask/trainRecordPage`, data,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })
          }
          const clearBtns = () =>{
              dateTime.value = []
              student.value = ""
              student_s.value = ""
              coursecancellationStatusInput.value = ""
              coursecancellationStatusInput_s.value = ""
              coursecancellationStatusInput_ss.value = ""
              dateTimeList.value = []
              input1.value = ""
              input2.value = ""
              input3.value = ""
              input4.value = ""
              input5.value = ""
              input6.value = ""
              input7.value = ""

              let data = { 
                    pageNum: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    teacherName: input1.value,
                    jobtitle: input2.value,
                    teach: input3.value,
                    trainPlan: input4.value,
                    recruitmentChannel: input5.value,
                    introducerName: input6.value,
                    bossName:input7.value,
                    entryTimeStart: dateTime.value[0] ? dateTime.value[0] + ' 00:00:00' : '',
                    entryTimeEnd: dateTime.value[1] ? dateTime.value[1] + ' 00:00:00' : '',
                }
                axios.post(`${apiBaseUrl}/trainTask/trainRecordPage`, data,{
                    headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    if(res.data.code == 200){
                        handleMessage("查询成功", 'success')
                    }
                    dataList.value = res.data.data.records
                    requestParameters.pageNum = res.data.data.current
                    requestParameters.pageSize = res.data.data.size
                    requestParameters.total = res.data.data.total

                }).catch(error => {
                    console.error(error)
                })

          }
          const addBtns = () =>{
              AddShowDlong.value = true
          }
  
          const handleSizeChange = (size) =>{
              requestParameters.pageSize = size

              let data = { 
                    pageNum: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    teacherName: input1.value,
                    jobtitle: input2.value,
                    teach: input3.value,
                    trainPlan: input4.value,
                    recruitmentChannel: input5.value,
                    introducerName: input6.value,
                    bossName:input7.value,
                    entryTimeStart: dateTime.value[0] ? dateTime.value[0] + ' 00:00:00': '',
                    entryTimeEnd: dateTime.value[1] ? dateTime.value[1] + ' 00:00:00' : '',
                }
                axios.post(`${apiBaseUrl}/trainTask/trainRecordPage`, data,{
                    headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    if(res.data.code == 200){
                        handleMessage("查询成功", 'success')
                    }
                    dataList.value = res.data.data.records
                    requestParameters.pageNum = res.data.data.current
                    requestParameters.pageSize = res.data.data.size
                    requestParameters.total = res.data.data.total

                }).catch(error => {
                    console.error(error)
                })
          }
          const handleCurrentChange = (page) =>{
              requestParameters.pageNum = page
              let data = { 
                    pageNum: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    teacherName: input1.value,
                    jobtitle: input2.value,
                    teach: input3.value,
                    trainPlan: input4.value,
                    recruitmentChannel: input5.value,
                    introducerName: input6.value,
                    bossName:input7.value,
                    entryTimeStart: dateTime.value[0] ? dateTime.value[0] + ' 00:00:00': '',
                    entryTimeEnd: dateTime.value[1] ? dateTime.value[1] + ' 00:00:00' : '',
                }
                axios.post(`${apiBaseUrl}/trainTask/trainRecordPage`, data,{
                    headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    if(res.data.code == 200){
                        handleMessage("查询成功", 'success')
                    }
                    dataList.value = res.data.data.records
                    requestParameters.pageNum = res.data.data.current
                    requestParameters.pageSize = res.data.data.size
                    requestParameters.total = res.data.data.total

                }).catch(error => {
                    console.error(error)
                })
          }
  
          const handleClickView = (boom, edible)=>{
              let { courseDate, courseEndTime, courseStartTime, subjectName } = edible
              form.student = courseStartTime
              form.student_s = courseEndTime
              form.coursecancellationStatusInput = subjectName
              form.dateTimeList = courseDate
              ShowDlong.value = true
              sessionStorage.setItem('detailsInfo',JSON.stringify(form))
              if(boom === '编辑'){
                  ShowDlongDisabled.value = false
                  ShowDlongTitle.value = '编辑'
              }
              if(boom === '详情'){
                
                // axios.post(`${apiBaseUrl}/trainTask/trainRecordInfo/${edible.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                //newEdible = edible
               axios.post(`${apiBaseUrl}/trainTask/trainRecordInfo/${edible.id}`, {},{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
                    isReturn(res.code)
                    if(res.data.code == 200){
                        // let { realname, teach, jobtitle, recruitmentChannel, introducerName, bossName, entryTime, teacherTrainTaskDTOS} = res.data.data
                        // realname.value = realname 
                        // teach.value = teach   
                        // jobtitle.value = jobtitle     
                        // recruitmentChannel.value = recruitmentChannel   
                        // introducerName.value = introducerName   
                        // bossName.value = bossName   
                        // entryTime.value = entryTime   
                        // taskList.value = teacherTrainTaskDTOS
                        

                        
                        let data = res.data.data
                        newEdible.realname = data.realname ? data.realname : '暂无'
                        newEdible.teach = data.teach ? data.teach : '暂无'
                        newEdible.jobtitle = data.jobTitleName ? data.jobTitleName : '暂无'
                        newEdible.recruitmentChannel = data.recruitmentChannel ? data.recruitmentChannel : '暂无'
                        newEdible.introducerName = data.introducerName ? data.introducerName : '暂无'
                        newEdible.bossName = data.bossName ? data.bossName : '暂无'
                        newEdible.entryTime = data.entryTime ? data.entryTime : '暂无'
                        newEdible.teacherTrainTaskDTOS = data.teacherTrainTaskDTOS ?  data.teacherTrainTaskDTOS : []


                        console.log(newEdible, 'newEdible')

                        resData.auditName = newEdible.realname

                        Rowrealname.value = newEdible.realname

                        ShowDlongDisabled.value = true
                        ShowDlongTitle.value = '培训档案详情'
                    }else{
                        handleMessage(res.data.message, 'error')
                    }

                }).catch(error => {
                    console.error(error)
                })
              }
          }
  
  
          const commitCler = () =>{
              Rowrealname.value = '' 
              newEdible.realname = ''
              newEdible.teach = ''
              newEdible.jobtitle = ''
              newEdible.recruitmentChannel = ''
              newEdible.introducerName = ''
              newEdible.bossName = ''
              newEdible.entryTime =  ''
              newEdible.teacherTrainTaskDTOS = []
              handleDayShowList.value = []
              handleDayShow.value = false
              handleTaskDayShow.value = false
              handleTaskDayRow.auditData = '' 
              handleTaskDayRow.auditName = ''
              handleTaskDayRow.auditName1 = ''
              handleTaskDayRow.auditStatus = 1
              handleTaskDayRow.cancelCause = ''
              handleTaskDayRow.isAnswer = ''
              handleTaskDayRow.isAnswerComplete = ''
              handleTaskDayRow.summarize = ''
              handleTaskDayRow.taskAnswer = ''
              handleTaskDayRow.taskAnswerName = ''
              handleTaskDayRow.taskContent = ''
              handleTaskDayRow.taskName = ''
              handleTaskDayRow.taskNumber = ''
              handleTaskDayRow.teacherPerformance = ''
              handleTaskDayRow.taskData = []
              handleTaskDayRowData.value = []
              handleTaskDayRow.auditOpinion = ''
              ShowDlong.value = false
              sessionStorage.setItem('detailsInfo',JSON.stringify(null))
              handleClrAll()
          }
  
          const commitAdd = (boomm) =>{
              if(boomm === 'No'){
                  ShowapprovalOpinions.value = true
              }
              if(boomm === 'Yes'){
                  ShowapprovalOpinions_Yes.value = true
              }
              ShowDlong.value = false
              handleClrAll()
          }
  
          const handleClrAll = () =>{
              form.student = ""
              form.student_s = ""
              form.coursecancellationStatusInput = []
              form.dateTimeList = ""
          }
  
          const AddcommitCler = () =>{
              AddShowDlong.value = false
              handleClerAllDing()
          }
  
          const AddcommitAdd = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
  
          const AddcommitSub = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
  
          const handleClerAllDing = () =>{
              fileDataList.value = []
              Addform.TrainName = ""
              Addform.CreatorName = ""
              Addform.TrainerName = ""
              Addform.TrainingContent = ""
              Addform.ApprovedName = ""
          }
  
          const clickitem = (itme) =>{
              console.log(itme, 'itme')
          }
  
          const handleRemove = (file, fileList) =>{
              fileDataList.value = fileList
          }
  
          const getFileName = (name) => {
               return name.substring(name.lastIndexOf("."))
          }
  
          const beforeUpload = (file, fileList) =>{
              loadingUtils.startLoading()
              const fileExtensions =
                  getFileName(file.name) === ".bmp" ||
                  getFileName(file.name) === ".tif" ||
                  getFileName(file.name) === ".gif" ||
                  getFileName(file.name) === ".pcx" ||
                  getFileName(file.name) === ".svg" ||
                  getFileName(file.name) === ".psd" ||
                  getFileName(file.name) === ".webp" ||
                  getFileName(file.name) === ".apng" ||
                  getFileName(file.name) === ".ai" ||
                  getFileName(file.name) === ".avif" ||
                  getFileName(file.name) === ".png" ||
                  getFileName(file.name) === ".pdf"||
                  getFileName(file.name) === ".mp4"||
                  getFileName(file.name) === ".excel"||
                  getFileName(file.name) === ".doc"||
                  getFileName(file.name) === ".ppt"||
                  getFileName(file.name) === ".mp3"||
                  getFileName(file.name) === ".xls"||
                  getFileName(file.name) === ".xlsx"||
                  getFileName(file.name) === ".pptx"||
                  getFileName(file.name) === ".docx"||
                  getFileName(file.name) === ".txt"||
                  getFileName(file.name) === ".jpg";
              const max20M = file.size / 1024 / 1024 < 1000;
  
              if (!fileExtensions) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
              if (!max20M) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
  
              return fileExtensions && max20M
          }
  
          const handleUpload = (option) =>{
              let obj = option.file.name
              let index = obj.lastIndexOf(".")
              obj = obj.substring(index, obj.length)
              let objName = getFileNameUUID() + getFileName(option.file.name)
              put(`mz_pc/${objName}`, option.file).then((res) => {
                  loadingUtils.endLoading()
                  signatureUrl(`mz_pc/${objName}`).then((res) => {})
              });
          }
  
          const handleError = () =>{
              loadingUtils.endLoading()
          }
  
  
          const AddapprovalOpinions = () =>{
              ShowapprovalOpinions.value = false
              approvalOpinionstextarea.value = ''
              handleMessage('提交了驳回','success')
          }
  
          const approvalOpinionsCler_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const AddapprovalOpinions_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              handleMessage('提交了通过','success')
          }
          
          const handleTask = (itme) => {

                console.log(itme, '第一层')

                if(itme.trainTaskDTOS.length < 1){
                    handleMessage('暂无培训任务','warning')
                }else{
                    handleDayShowList.value = itme
                    handleDayShow.value = true
                }
                handleTaskDayRow.taskName = itme.trainName
          }

          const handleDay = (itme) => {

             console.log(itme, '第二层')


             if(Array.isArray(itme.taskData)){
                resData.taskData = itme.taskData
             }else{
                resData.taskData = JSON.parse(itme.taskData)
             }

             if(Array.isArray(itme.auditData)){
                resData.auditData = itme.auditData
             }else{
                resData.auditData = JSON.parse(itme.auditData)
             }
             resData.taskContent = itme.taskContent
             resData.trainName = itme.trainName
             resData.teacherName = itme.teacherName
             resData.createTime = itme.createTime
             resData.teacherId = itme.teacherId
             resData.taskName = itme.taskName
             resData.summarize = itme.summarize
             resData.cancelCause = itme.cancelCause
             resData.auditStatus = itme.auditStatus
             resData.auditOpinion = itme.auditOpinion
             resData.commitDate = itme.commitDate
             resData.auditName1 = itme.auditName
             resData.summarize = itme.summarize


            //  handleTaskDayRow = itme
            //  handleTaskDayShow.value = true
            ShowDlongTitle1.value = '任务详情'
            ShowDlong1.value = true
               
          }

          const commitCler1 = () =>{
             ShowDlong1.value = false
          } 

          const handleStep = (itme,index) => {
                activeStep.value = index
          }
  
          return {
              handleDayShow,
              handleTaskDayRow,
              handleTaskDayShow,
              handleStep,
              handleDay,
              dayTaskList,
              handleTask,
              handleUpload,
              beforeUpload,
              handleError,
              getFileName,
              handleRemove,
              handleClerAllDing,
              fileDataList,
              clickitem,
              AddcommitCler,
              AddcommitAdd,
              commitCler,
              commitAdd,
              handleMessage,
              getStudentsArr,
              getStudentsArr_s,
              coursecancellationStatus,
              student,
              student_s,
              planArr,
              coursecancellationStatusInput,
              coursecancellationStatusInput_s,
              coursecancellationStatusInput_ss,
              dateTimeList,
              handleAllApi,
              exportBtns,
              dayList,
              searchBtns,
              clearBtns,
              addBtns,
              dataList,
              handleTaskDayRowData,
              ShowDlongTitle1,
              ShowDlong1,
              commitCler1,
              handleClickView,
              handleSizeChange,
              handleCurrentChange,
              requestParameters,
              ShowDlongTitle,
              ShowDlong,
              form,
              ShowDlongDisabled,
              handleClrAll,
              AddcommitSub,
              AddShowDlong,
              Addform,
              ShowapprovalOpinions,
              approvalOpinionsCler,
              approvalOpinionstextarea,
              AddapprovalOpinions,
              ShowapprovalOpinions_Yes,
              approvalOpinionsCler_Yes,
              AddapprovalOpinions_Yes,
              taskList,
              activeStep,
              dateStepList,
              resData,
              coursecancellationStatuss,
              coursecancellationStatusss,
              input1,
              input2,
              input3,
              input4,
              input5,
              input6,
              input7,
              realname, teach, jobtitle, recruitmentChannel, introducerName, bossName, entryTime,newEdible,
              handleDayShowList,
              Rowrealname,
              dateTime,
          }
  
      }
  
  })
  
  
  </script>
  
  <style scoped  lang="less">
  
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  
  /deep/ .el-upload{
      width: 100% !important;
  }
  /deep/ .el-form-item__label{
      text-align: start;
  }
  
/deep/ .el-step__icon{
    display: none;
}

/deep/ .is-simple{
    margin-right: 20px;
}

/deep/ .el-step__main{
    width: 80px;
}

/deep/ .el-steps--simple{
    background: #fff;
}


/deep/ .is-process{
    color: #09a3e0 !important;
}

/deep/ .is-finish{
    color: #000 !important; 
}

.disable-click {
  pointer-events: none;
}

.cssCls{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
  </style>


// WEBPACK FOOTER //
// src/initAssembly/trainingFiles.vue